export default "__VITE_ASSET___9JD9bIE__"